import Amplify from '@aws-amplify/core';
import '@aws-amplify/auth';
import config from './config';

export function configure() {
  Amplify.configure(config.auth.cognito);
}
